/**
 * @generated SignedSource<<a48b9e889190c7c09674a7dd5ac8e6ad>>
 * @relayHash 6cf6e1b0fe705a1cbeb674d34fba76cf
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID cf32d4dcb13c72ad33444138750f38aceececce051dbeaa4df3830ba6cfaec78

import type { ConcreteRequest, Query } from 'relay-runtime';
export type GraphIntegrationDirectoryItemType = "ACTION" | "MCP_SERVER" | "MCP_TOOL" | "SKILL" | "%future added value";
export type GraphIntegrationSkillColor = "BLUE" | "DEFAULT" | "GRAY" | "GREEN" | "LIME" | "MAGENTA" | "ORANGE" | "PURPLE" | "RED" | "TEAL" | "YELLOW" | "%future added value";
export type GraphIntegrationSurface = "AUTOMATION" | "POLLINATOR" | "ROVO" | "STUDIO" | "%future added value";
export type composableEditorChat_GetDirectoryItemsQuery$variables = {
  after?: string | null | undefined;
  cloudId: string;
  dimensionIds?: ReadonlyArray<string> | null | undefined;
  first?: number | null | undefined;
  relevantFor: ReadonlyArray<GraphIntegrationDirectoryItemType>;
  searchKeyword?: string | null | undefined;
  shouldFetch?: boolean | null | undefined;
  surface?: GraphIntegrationSurface | null | undefined;
};
export type composableEditorChat_GetDirectoryItemsQuery$data = {
  readonly graphIntegration_componentDirectoryItems?: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly __typename: "GraphIntegrationSkillDirectoryItem";
        readonly color: GraphIntegrationSkillColor | null | undefined;
        readonly description: string | null | undefined;
        readonly iconUrl: string | null | undefined;
        readonly id: string;
        readonly integrationKey: {
          readonly displayName: string;
          readonly iconUrl: string | null | undefined;
        } | null | undefined;
        readonly name: string;
        readonly slashCommand: string | null | undefined;
      } | {
        // This will never be '%other', but we need some
        // value in case none of the concrete values match.
        readonly __typename: "%other";
      } | null | undefined;
    }>;
    readonly error: {
      readonly extensions: ReadonlyArray<{
        readonly errorType: string | null | undefined;
        readonly statusCode: number | null | undefined;
      }> | null | undefined;
      readonly message: string | null | undefined;
    } | null | undefined;
    readonly pageInfo: {
      readonly endCursor: string | null | undefined;
      readonly hasNextPage: boolean;
      readonly hasPreviousPage: boolean;
      readonly startCursor: string | null | undefined;
    };
  } | null | undefined;
};
export type composableEditorChat_GetDirectoryItemsQuery = {
  response: composableEditorChat_GetDirectoryItemsQuery$data;
  variables: composableEditorChat_GetDirectoryItemsQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "after"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "cloudId"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "dimensionIds"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "first"
},
v4 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "relevantFor"
},
v5 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "searchKeyword"
},
v6 = {
  "defaultValue": false,
  "kind": "LocalArgument",
  "name": "shouldFetch"
},
v7 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "surface"
},
v8 = {
  "kind": "Variable",
  "name": "cloudId",
  "variableName": "cloudId"
},
v9 = {
  "kind": "Variable",
  "name": "dimensionIds",
  "variableName": "dimensionIds"
},
v10 = {
  "kind": "Variable",
  "name": "relevantFor",
  "variableName": "relevantFor"
},
v11 = {
  "kind": "Variable",
  "name": "searchKeyword",
  "variableName": "searchKeyword"
},
v12 = {
  "kind": "Variable",
  "name": "surface",
  "variableName": "surface"
},
v13 = {
  "kind": "ScalarField",
  "name": "__typename"
},
v14 = {
  "kind": "ScalarField",
  "name": "id"
},
v15 = {
  "kind": "ScalarField",
  "name": "slashCommand"
},
v16 = {
  "kind": "ScalarField",
  "name": "name"
},
v17 = {
  "kind": "ScalarField",
  "name": "description"
},
v18 = {
  "kind": "ScalarField",
  "name": "iconUrl"
},
v19 = {
  "kind": "ScalarField",
  "name": "displayName"
},
v20 = {
  "kind": "ScalarField",
  "name": "color"
},
v21 = {
  "kind": "ScalarField",
  "name": "cursor"
},
v22 = {
  "concreteType": "PageInfo",
  "kind": "LinkedField",
  "name": "pageInfo",
  "plural": false,
  "selections": [
    {
      "kind": "ScalarField",
      "name": "hasNextPage"
    },
    {
      "kind": "ScalarField",
      "name": "hasPreviousPage"
    },
    {
      "kind": "ScalarField",
      "name": "startCursor"
    },
    {
      "kind": "ScalarField",
      "name": "endCursor"
    }
  ]
},
v23 = {
  "kind": "ScalarField",
  "name": "message"
},
v24 = {
  "kind": "ScalarField",
  "name": "statusCode"
},
v25 = {
  "kind": "ScalarField",
  "name": "errorType"
},
v26 = [
  {
    "kind": "Variable",
    "name": "after",
    "variableName": "after"
  },
  (v8/*: any*/),
  (v9/*: any*/),
  {
    "kind": "Variable",
    "name": "first",
    "variableName": "first"
  },
  (v10/*: any*/),
  (v11/*: any*/),
  (v12/*: any*/)
],
v27 = [
  (v14/*: any*/)
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/),
      (v5/*: any*/),
      (v6/*: any*/),
      (v7/*: any*/)
    ],
    "kind": "Fragment",
    "name": "composableEditorChat_GetDirectoryItemsQuery",
    "selections": [
      {
        "condition": "shouldFetch",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
          {
            "alias": "graphIntegration_componentDirectoryItems",
            "args": [
              (v8/*: any*/),
              (v9/*: any*/),
              (v10/*: any*/),
              (v11/*: any*/),
              (v12/*: any*/)
            ],
            "concreteType": "GraphIntegrationDirectoryItemConnection",
            "kind": "LinkedField",
            "name": "__Skills__graphIntegration_componentDirectoryItems_connection",
            "plural": false,
            "selections": [
              {
                "concreteType": "GraphIntegrationDirectoryItemEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v13/*: any*/),
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          (v14/*: any*/),
                          (v15/*: any*/),
                          (v16/*: any*/),
                          (v17/*: any*/),
                          (v18/*: any*/),
                          {
                            "concreteType": "GraphIntegrationDirectoryFilterDimension",
                            "kind": "LinkedField",
                            "name": "integrationKey",
                            "plural": false,
                            "selections": [
                              (v19/*: any*/),
                              (v18/*: any*/)
                            ]
                          },
                          (v20/*: any*/)
                        ],
                        "type": "GraphIntegrationSkillDirectoryItem"
                      }
                    ]
                  },
                  (v21/*: any*/)
                ]
              },
              (v22/*: any*/),
              {
                "concreteType": "QueryError",
                "kind": "LinkedField",
                "name": "error",
                "plural": false,
                "selections": [
                  (v23/*: any*/),
                  {
                    "kind": "LinkedField",
                    "name": "extensions",
                    "plural": true,
                    "selections": [
                      (v24/*: any*/),
                      (v25/*: any*/)
                    ]
                  }
                ]
              }
            ]
          }
        ]
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v3/*: any*/),
      (v0/*: any*/),
      (v2/*: any*/),
      (v5/*: any*/),
      (v4/*: any*/),
      (v1/*: any*/),
      (v7/*: any*/),
      (v6/*: any*/)
    ],
    "kind": "Operation",
    "name": "composableEditorChat_GetDirectoryItemsQuery",
    "selections": [
      {
        "condition": "shouldFetch",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
          {
            "args": (v26/*: any*/),
            "concreteType": "GraphIntegrationDirectoryItemConnection",
            "kind": "LinkedField",
            "name": "graphIntegration_componentDirectoryItems",
            "plural": false,
            "selections": [
              {
                "concreteType": "GraphIntegrationDirectoryItemEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v13/*: any*/),
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          (v14/*: any*/),
                          (v15/*: any*/),
                          (v16/*: any*/),
                          (v17/*: any*/),
                          (v18/*: any*/),
                          {
                            "concreteType": "GraphIntegrationDirectoryFilterDimension",
                            "kind": "LinkedField",
                            "name": "integrationKey",
                            "plural": false,
                            "selections": [
                              (v19/*: any*/),
                              (v18/*: any*/),
                              (v14/*: any*/)
                            ]
                          },
                          (v20/*: any*/)
                        ],
                        "type": "GraphIntegrationSkillDirectoryItem"
                      },
                      {
                        "kind": "InlineFragment",
                        "selections": (v27/*: any*/),
                        "type": "GraphIntegrationActionDirectoryItem"
                      },
                      {
                        "kind": "InlineFragment",
                        "selections": (v27/*: any*/),
                        "type": "GraphIntegrationMcpServer"
                      },
                      {
                        "kind": "InlineFragment",
                        "selections": (v27/*: any*/),
                        "type": "GraphIntegrationMcpTool"
                      }
                    ]
                  },
                  (v21/*: any*/)
                ]
              },
              (v22/*: any*/),
              {
                "concreteType": "QueryError",
                "kind": "LinkedField",
                "name": "error",
                "plural": false,
                "selections": [
                  (v23/*: any*/),
                  {
                    "kind": "LinkedField",
                    "name": "extensions",
                    "plural": true,
                    "selections": [
                      (v13/*: any*/),
                      (v24/*: any*/),
                      (v25/*: any*/)
                    ]
                  }
                ]
              }
            ]
          },
          {
            "args": (v26/*: any*/),
            "filters": [
              "dimensionIds",
              "searchKeyword",
              "relevantFor",
              "cloudId",
              "surface"
            ],
            "handle": "connection",
            "key": "Skills__graphIntegration_componentDirectoryItems",
            "kind": "LinkedHandle",
            "name": "graphIntegration_componentDirectoryItems"
          }
        ]
      }
    ]
  },
  "params": {
    "id": "cf32d4dcb13c72ad33444138750f38aceececce051dbeaa4df3830ba6cfaec78",
    "metadata": {
      "connection": [
        {
          "count": "first",
          "cursor": "after",
          "direction": "forward",
          "path": [
            "graphIntegration_componentDirectoryItems"
          ]
        }
      ]
    },
    "name": "composableEditorChat_GetDirectoryItemsQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "f46e4cb4d282d17fc9f6094439d99708";

export default node;
